<header
  class="flex bg-surface-container text-on-surface items-center justify-between transition-colors duration-300 py-2 px-2 sm:py-2.5 sm:px-4 lg:py-3 lg:px-6"
>
  <!-- Left side: Event info -->
  <div class="flex items-center gap-2 sm:gap-3 lg:gap-4 flex-1 min-w-0 max-w-[35%] sm:max-w-none">
    <ng-content select="[header-left]"></ng-content>
  </div>

  <!-- Center: Logo -->
  <div class="flex items-center justify-center flex-shrink-0 mx-1 sm:mx-3 lg:mx-4">
    @if (logoLink()) {
      <a [href]="logoLink()" [target]="logoLinkTarget()">
        @if (centerImageSrc()) {
          <img
            [src]="centerImageSrc()"
            [alt]="centerImageAlt()"
            class="header-logo h-5 sm:h-7 lg:h-10 object-contain"
          />
        }
      </a>
    } @else {
      @if (centerImageSrc()) {
        <img
          [src]="centerImageSrc()"
          [alt]="centerImageAlt()"
          class="header-logo h-5 sm:h-7 lg:h-10 object-contain"
        />
      }
    }
  </div>

  <!-- Right side: Controls -->
  <div
    class="flex items-center gap-0.5 sm:gap-1.5 lg:gap-2 flex-1 justify-end max-w-[35%] sm:max-w-none"
  >
    <ng-content select="[header-right]"></ng-content>
  </div>
</header>
